import { AxiosInstance } from './axios.core';

import { API_URL } from './api.base';

import { ChatMessage, ChatSession, SessionListResponse } from './models';

export const getSessions = async (): Promise<any> => {
  const response = await AxiosInstance.get(`${API_URL}/api/v1/sessions`);
  return response;
};

export const getSessionMessages = async (sessionId: string): Promise<any> => {
  const response = await AxiosInstance.get(`${API_URL}/api/v1/sessions/${sessionId}/messages`);
  return response;
}

export const createSession = async ( params: any): Promise<any> => {
  const response = await AxiosInstance.post(`${API_URL}/api/v1/sessions`, { ...params });
  return response;
}

export const deleteSession = async (sessionId: string): Promise<any> => {
  const response = await AxiosInstance.delete(`${API_URL}/api/v1/sessions${sessionId}`);
  return response;
}
